export const SOFTLINE_API_DOCUMENT_QUERY_TYPES =
  '/document-query-service/document/query/types';
export const SOFTLINE_API_DOCUMENT_QUERY =
  '/document-query-service/document/query/{{documentType}}';
export const SOFTLINE_API_DOCUMENT_QUERY_RECENT =
  '/document-query-service/document/query/recent';
export const SOFTLINE_API_DOCUMENT_QUERY_ICONS =
  '/document-query-service/document/query/icons';
/** Documents linked to one document as its Geschäftsfall. Same query contract and
    same fields as the recent documents; `{documentId}` is the composite document
    id (e.g. `SALES_ORDER_282625`). */
export const SOFTLINE_API_DOCUMENT_QUERY_BUSINESS_CASE =
  '/document-query-service/document/query/business-case/{{documentId}}';

export const SOFTLINE_API_SALES_DOCUMENT =
  '/sales-document-service/sales-document-service/documents';
export const SOFTLINE_API_SALES_DOCUMENT_STASHED =
  '/sales-document-service/sales-document-service/stashed-documents/{{userId}}';
export const SOFTLINE_API_SALES_DOCUMENT_POSTPONE =
  '/sales-document-service/sales-document-service/documents/{{id}}/postpone';
export const SOFTLINE_API_SALES_DOCUMENT_FINALIZE =
  '/sales-document-service/sales-document-service/documents/{{id}}/finalize';
export const SOFTLINE_API_SALES_DOCUMENT_FINALIZE_STEPS =
  '/sales-document-service/sales-document-service/documents/{{id}}/finalize-steps';
export const SOFTLINE_API_SALES_DOCUMENT_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}';
/** Graphical signature of a FINALIZED document: POST uploads it as
    multipart/form-data (one signature per document, a second upload is
    rejected), GET returns the raw image. `{id}` is the finalize response's
    `key` — the draft no longer exists and is not signable. */
export const SOFTLINE_API_SALES_DOCUMENT_SIGNATURE =
  '/sales-document-service/sales-document-service/documents/{{id}}/signature';
/** Creates the Anzahlungsgutschrift for an Auftrag (Ticket 452.648). The document
    id travels in the path and an empty body is valid; the response is the SOURCE
    Auftrag carrying a new negative downPaymentEntry, not the created Gutschrift. */
export const SOFTLINE_API_SALES_DOCUMENT_DOWN_PAYMENT_CREDIT_NOTES =
  '/sales-document-service/sales-document-service/documents/{{id}}/down-payment-credit-notes';
export const SOFTLINE_API_SALES_DOCUMENT_VALIDATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/validate';
export const SOFTLINE_API_SALES_DOCUMENT_DISCOUNTS =
  '/sales-document-service/sales-document-service/documents/{{id}}/discounts';
export const SOFTLINE_API_SALES_DOCUMENT_DISCOUNT_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/discounts/{{conditionId}}';
export const SOFTLINE_API_SALES_DOCUMENT_TYPES =
  '/sales-document-service/sales-document-service/document-types';
export const SOFTLINE_API_SALES_DOCUMENT_TYPES_FOR_DOCUMENT =
  '/sales-document-service/sales-document-service/document-types/{{id}}';

export const SOFTLINE_API_SALES_DOCUMENT_ITEMS =
  '/sales-document-service/sales-document-service/documents/{{id}}/items';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_ATTRIBUTES =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/attributes';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_CONFIRMATIONS =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/confirmations';
/** Retourbezug candidates (ClickUp 869e5mt0w): source-document positions the
    returned quantity can reference. POST only for the body; `{}` is valid. */
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_RETURNING_ITEM_REFERENCES =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/returning-item-references';
export const SOFTLINE_API_SALES_DOCUMENT_ITEMS_DELETE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/delete';
export const SOFTLINE_API_SALES_DOCUMENT_ITEMS_TEMPLATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/template';
// Backend spelling: doubled l ("fullfill"), Ticket 451499 — do not "fix" it.
export const SOFTLINE_API_SALES_DOCUMENT_FULFILL =
  '/sales-document-service/sales-document-service/documents/{{id}}/fullfill';
export const SOFTLINE_API_SALES_DOCUMENT_CLONE =
  '/sales-document-service/sales-document-service/documents/clone';
export const SOFTLINE_API_SALES_DOCUMENT_ITEMS_MOVE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/move';
export const SOFTLINE_API_SALES_DOCUMENT_ITEMS_ADD_TO_NEW_SECTION =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/add-to-new-section';
export const SOFTLINE_API_SALES_DOCUMENT_ITEMS_ADD_TO_NEW_FLATRATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/add-to-new-flatrate';
export const SOFTLINE_API_SALES_DOCUMENT_ITEMS_UNDO_FLATRATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/undo-flatrate';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_RECALCULATE_PRICE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/recalculate-price';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_UNIT_COMPOSITION =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/unit-composition';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_UNIT_COMPOSITION_CALCULATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/unit-composition/calculate';
/** Modul-Optionen of an ARTICLE — pure query, records nothing (POST only for
    the body). An empty array means the article is not a module with options. */
export const SOFTLINE_API_PRODUCT_MODULE_OPTIONS =
  '/sales-document-service/sales-document-service/products/{{productId}}/module-options';
/** Modul-Optionen of an existing POSITION: GET reads the persisted selection,
    PUT replaces it (components are dropped and re-resolved with new ids). */
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_MODULE_OPTIONS =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/module-options';

export const SOFTLINE_API_SALES_DOCUMENT_ITEM_PRICE_INFO =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/price-info';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_DISCOUNTS =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/discounts';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_DISCOUNT_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/discounts/{{conditionId}}';

export const SOFTLINE_API_SALES_DOCUMENT_META_CONFIGURATION =
  '/sales-document-service/sales-document-service/meta/configuration';

export const SOFTLINE_API_SALES_DOCUMENT_META_SELECT_OPTIONS =
  '/sales-document-service/sales-document-service/meta/select-options';

/** Item fields whose planned change must be pre-checked via the confirmations
    endpoint before the PATCH (ClickUp 869e5mt0w, e.g. `salesQuantity`). */
export const SOFTLINE_API_SALES_DOCUMENT_META_ITEM_CONFIRMATION_FIELDS =
  '/sales-document-service/sales-document-service/meta/item/confirmation-fields';

/** Status transitions a document currently allows (`SET_LOST`, `CANCEL`, …).
    Each one maps to the PUT (set) / DELETE (undo) pair of the matching path
    below — the list decides which of them may be offered. */
export const SOFTLINE_API_SALES_DOCUMENT_ACTIONS =
  '/sales-document-service/sales-document-service/documents/{{id}}/actions';
/** PUT sets the flag, DELETE undoes it — all six status paths share that pair. */
export const SOFTLINE_API_SALES_DOCUMENT_PIN =
  '/sales-document-service/sales-document-service/documents/{{id}}/pin';
export const SOFTLINE_API_SALES_DOCUMENT_PAY =
  '/sales-document-service/sales-document-service/documents/{{id}}/pay';
export const SOFTLINE_API_SALES_DOCUMENT_LOSE =
  '/sales-document-service/sales-document-service/documents/{{id}}/lose';
export const SOFTLINE_API_SALES_DOCUMENT_DONE =
  '/sales-document-service/sales-document-service/documents/{{id}}/done';
export const SOFTLINE_API_SALES_DOCUMENT_CANCEL =
  '/sales-document-service/sales-document-service/documents/{{id}}/cancel';
/** Fakturenfreigabe of a Lieferschein. */
export const SOFTLINE_API_SALES_DOCUMENT_APPROVE =
  '/sales-document-service/sales-document-service/documents/{{id}}/approve';
/** Undoes the deletion of a Lieferschein — the only path under
    `delivery-notes`, not under `documents`. */
export const SOFTLINE_API_SALES_DELIVERY_NOTE_RESTORE =
  '/sales-document-service/sales-document-service/delivery-notes/{{id}}/restore';

/** Signature handshake around the POS display: `start` asks the display to
    capture, `started` reports that it did, `request` re-asks for one. All three
    are plain POSTs with no body — the actual image travels over
    SOFTLINE_API_SALES_DOCUMENT_SIGNATURE. */
export const SOFTLINE_API_SALES_DOCUMENT_SIGNATURE_START =
  '/sales-document-service/sales-document-service/documents/{{id}}/signature/start';
export const SOFTLINE_API_SALES_DOCUMENT_SIGNATURE_STARTED =
  '/sales-document-service/sales-document-service/documents/{{id}}/signature/started';
export const SOFTLINE_API_SALES_DOCUMENT_SIGNATURE_REQUEST =
  '/sales-document-service/sales-document-service/documents/{{id}}/signature/request';

/** Anzahlung on a document (POST only — entries are read off the document's
    `downPaymentEntries`). */
export const SOFTLINE_API_SALES_DOCUMENT_DOWN_PAYMENTS =
  '/sales-document-service/sales-document-service/documents/{{id}}/down-payments';

/** Emballagen carried by the document itself — distinct from the
    Standführung query in SOFTLINE_API_RETURNABLE_PACKAGING, which is a
    different service. GET lists them, POST creates the positions. */
export const SOFTLINE_API_SALES_DOCUMENT_PACKAGING_PRODUCTS =
  '/sales-document-service/sales-document-service/documents/{{id}}/packaging-products';

/** Aufmaßblatt of an ARTICLE — pure calculation, records nothing. */
export const SOFTLINE_API_PRODUCT_CALCULATION_SHEET =
  '/sales-document-service/sales-document-service/products/{{productId}}/calculation-sheet';
/** Aufmaßblatt of an existing POSITION: GET reads the stored sheet, PUT
    recalculates AND persists it (the response is the item update, not the
    sheet). */
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_CALCULATION_SHEET =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/calculation-sheet';

/** Bestellung attached to ONE position. DELETE takes the purchase order id in
    the last segment (the DTO calls it `ekId`, the discount paths call the same
    id `purchaseOrderId`). */
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_PURCHASE_ORDER =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/purchase-order';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_PURCHASE_ORDER_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/purchase-order/{{purchaseOrderId}}';
/** Einkaufsrabatte of that Bestellung — the response is the PRICE, not the item. */
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_PURCHASE_ORDER_DISCOUNTS =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/purchase-order/{{purchaseOrderId}}/discounts';
export const SOFTLINE_API_SALES_DOCUMENT_ITEM_PURCHASE_ORDER_DISCOUNT_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/items/{{itemId}}/purchase-order/{{purchaseOrderId}}/discounts/{{discountId}}';

/** Bestellvorschläge across all documents — not scoped to one document, which
    is why the path has no `documents/{id}` prefix. `{{id}}` addresses a single
    proposed ITEM (PATCH supplier/delivery date, DELETE drops it). */
export const SOFTLINE_API_SALES_PURCHASE_ORDER_REQUESTS =
  '/sales-document-service/sales-document-service/purchase-order-requests';
export const SOFTLINE_API_SALES_PURCHASE_ORDER_REQUEST_BY_ID =
  '/sales-document-service/sales-document-service/purchase-order-requests/{{id}}';
/** Turns the selected proposals into real Bestellungen; the body is an ARRAY
    of `{sourceDocumentId, purchaseOrderRequestItemIds}`. */
export const SOFTLINE_API_SALES_PURCHASE_ORDER_REQUESTS_FINALIZE =
  '/sales-document-service/sales-document-service/purchase-order-requests/finalize';

/** Korrektur (Retoure/Nachlieferung) of a finalized document. GET returns the
    editable model, POST applies it, `/validate` previews the outcome without
    writing. `/products/{productId}` resolves an article that is not on the
    origin document into a correction line. */
export const SOFTLINE_API_SALES_DOCUMENT_CORRECTION =
  '/sales-document-service/sales-document-service/documents/{{id}}/correction';
export const SOFTLINE_API_SALES_DOCUMENT_CORRECTION_VALIDATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/correction/validate';
export const SOFTLINE_API_SALES_DOCUMENT_CORRECTION_PRODUCT =
  '/sales-document-service/sales-document-service/documents/{{id}}/correction/products/{{productId}}';

/** Lagerplätze of a stock. `/scan/{barcode}` resolves a scanned label to one,
    `/proposal` asks for the suggested location (query params `productId`,
    optional `unitId` and `quantity`). */
export const SOFTLINE_API_SALES_STORAGE_LOCATIONS =
  '/sales-document-service/sales-document-service/stocks/{{stockId}}/storage-locations';
export const SOFTLINE_API_SALES_STORAGE_LOCATION_SCAN =
  '/sales-document-service/sales-document-service/stocks/{{stockId}}/storage-locations/scan/{{barcode}}';
export const SOFTLINE_API_SALES_STORAGE_LOCATION_PROPOSAL =
  '/sales-document-service/sales-document-service/stocks/{{stockId}}/storage-locations/proposal';

/** Zahlung (Kassa) on a document. `scan/{labelType}/{code}` books a scanned
    voucher; `{{paymentEntryId}}` deletes one entry. Every one of them answers
    the FULL payment state, not just the touched entry. */
export const SOFTLINE_API_SALES_DOCUMENT_MONETARY_PAYMENT =
  '/sales-document-service/sales-document-service/documents/{{id}}/monetary-payment';
export const SOFTLINE_API_SALES_DOCUMENT_MONETARY_PAYMENT_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/monetary-payment/{{paymentEntryId}}';
export const SOFTLINE_API_SALES_DOCUMENT_MONETARY_PAYMENT_SCAN =
  '/sales-document-service/sales-document-service/documents/{{id}}/monetary-payment/scan/{{labelType}}/{{code}}';
export const SOFTLINE_API_SALES_DOCUMENT_MONETARY_PAYMENT_METHODS =
  '/sales-document-service/sales-document-service/documents/{{id}}/monetary-payment-methods';

/** The full catalog of item fields the backend may ever mark editable — the
    per-position `editableFields` is a subset of it. */
export const SOFTLINE_API_SALES_DOCUMENT_META_ITEM_EDITABLE_FIELDS =
  '/sales-document-service/sales-document-service/meta/item/editable-fields';

/** Kunden-Artikel-Statistik (customer-product-statistics-service).
    QUIRK: "article" is the backend's endpoint wording — frontend code says
    "product". */
export const SOFTLINE_API_CUSTOMER_PRODUCT_DATA =
  '/customer-product-statistics-service/customer-article-data';

/** Emballagen-Abfrage / Standführung (returnablepackaging-service).
    Path verified on PosDev (OPTIONS → `allow: POST,OPTIONS`); the request body
    is still provisional — see `types/returnable-packaging.ts`. */
export const SOFTLINE_API_RETURNABLE_PACKAGING =
  '/returnablepackaging-service/returnable-packaging';
